import { render } from "./mention_link.vue?vue&type=template&id=3d124500"
import script from "./mention_link.js?vue&type=script&lang=js"
export * from "./mention_link.js?vue&type=script&lang=js"

import "./mention_link.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__